<template>
  <div class="select-com">
    <van-field @click="showPicker = !showPicker" is-link readonly v-bind="$attrs" v-model="result" />

    <van-popup position="bottom" v-model="showPicker">
      <van-picker
        :columns="list"
        :default-index="defaultIndex"
        :item-height="$vanItemHeight"
        :title="$attrs.label"
        @cancel="showPicker = !showPicker"
        @confirm="onConfirm"
        show-toolbar
        value-key="name"
      />
    </van-popup>
  </div>
</template>

<script>
import number from '../../a.framework/utils/number'
export default {
  props: {
    columns: {
      type: Array
    },
    defaultIndex: {
      type: Number
    },
    resultVal: {
      type: String
    }
  },
  data() {
    return {
      result: '',
      showPicker: false,
      list: [],
      defaultInx: ''
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.list = this.columns
      this.result = this.resultVal
      this.defaultInx = this.defaultIndex
    },
    onConfirm(val) {
      this.result = val.name
      this.showPicker = !this.showPicker
      this.$emit('input', val)
    }
  },
  watch: {
    columns() {
      this.list = this.columns
    },
    defaultIndex() {
      this.defaultInx = this.defaultIndex
    },
    result() {
      this.result = this.resultVal
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
